var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zendesk__Integration=Zendesk, Size=24",
    className: "zendesk__Integration=Zendesk, zendesk__Size=24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "zendesk__Vector",
    fill: "#03363D",
    d: "M11.163 8.064v12.272H1L11.163 8.064Zm0-4.402a5.075 5.075 0 0 1-5.076 5.076C3.283 8.738 1 6.466 1 3.662h10.163Zm1.674 16.674a5.075 5.075 0 0 1 5.076-5.076 5.075 5.075 0 0 1 5.076 5.076H12.837Zm0-4.402V3.662H23L12.837 15.934Z",
    className: "zendesk__Vector"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/Zendesk.7630812f0bd0ddf3045b7381c6da0432.svg";
export { ForwardRef as ReactComponent };